// extracted by mini-css-extract-plugin
export default {"root":"PlaceholderRow-root_z9Q6b"};